<template>
  <!-- Begin: Services -->
  <div
    id="servicesPortlet"
    class="col-xl"
    data-section="Dashboard"
  >
    <!--begin::Portlet-->
    <div class="m-portlet m-portlet--rounded m-portlet--head-sm">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text">
              {{ $t("Dashboard.services") }}
            </h3>
          </div>
        </div>
      </div>
      <div class="m-portlet__body">
        <!--begin::m-widget5-->
        <div class="m-widget5">
          <div class="m-widget5__item pt-1 pb-0">
            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <h4 class="m-widget5__title">
                  <span v-if="premiumFeaturedProperties > 0">{{
                    premiumFeaturedProperties
                  }}</span>
                  {{ $t("services.PremiumFeaturedPropertyListing") }}
                </h4>
              </div>
            </div>

            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <div class="pt-0 m-widget5__stats1">
                  <div>
                    <template v-if="premiumFeaturedProperties > 0">
                      <span v-if="propertyService.Status === 'ACTIVE_SUSPENDED'">
                        <span class="font-weight-bold m--font-danger">{{
                          $t("homepage.services.onhold")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'ACTIVE_PENDING'">
                        <span class="font-weight-bold m--font-danger">{{
                          $t("homepage.services.pendingactivation")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'ACTIVE_EXPIRED'">
                        <span class="font-weight-bold m--font-orange">{{
                          $t("homepage.services.activeexpiredWithDate", { date: endDate })
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'ACTIVE_FUTURE'">
                        <span class="font-weight-bold m--font-orange">{{
                          $t("homepage.services.activeFutureWithDate", { date: startDate })
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'ACTIVE'">
                        <span class="font-weight-bold m--font-success">{{
                          $t("homepage.services.active")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'NOT_ACTIVE'">
                        <span class="font-weight-bold m--font-danger">{{
                          $t("homepage.services.notactive")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'NO_RESULTS'">
                        <span class="font-weight-bold m--font-danger">{{
                          $t("homepage.services.notcontracted")
                        }}</span>
                      </span>
                    </template>
                    <template v-else>
                      <span class="font-weight-bold m--font-danger">{{
                        $t("homepage.services.notcontracted")
                      }}</span>
                    </template>
                  </div>
                  <br>
                </div>
              </div>
            </div>
          </div>

          <div class="m-widget5__item pt-1 pb-0">
            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <h4 class="m-widget5__title">
                  <span v-if="featuredProperties > 0">{{
                    featuredProperties
                  }}</span>
                  {{ $t("services.FeaturedPropertyListing") }}
                </h4>
              </div>
            </div>

            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <div class="pt-0 m-widget5__stats1">
                  <div>
                    <template v-if="featuredProperties > 0">
                      <span v-if="propertyService.Status === 'ACTIVE_SUSPENDED'">
                        <span class="font-weight-bold m--font-danger">{{
                          $t("homepage.services.onhold")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'ACTIVE_PENDING'">
                        <span class="font-weight-bold m--font-danger">{{
                          $t("homepage.services.pendingactivation")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'ACTIVE_EXPIRED'">
                        <span class="font-weight-bold m--font-orange">{{
                          $t("homepage.services.activeexpiredWithDate", { date: endDate })
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'ACTIVE_FUTURE'">
                        <span class="font-weight-bold m--font-orange">{{
                          $t("homepage.services.activeFutureWithDate", { date: startDate })
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'ACTIVE'">
                        <span class="font-weight-bold m--font-success">{{
                          $t("homepage.services.active")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'NOT_ACTIVE'">
                        <span class="font-weight-bold m--font-danger">{{
                          $t("homepage.services.notactive")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status === 'NO_RESULTS'">
                        <span class="font-weight-bold m--font-danger">{{
                          $t("homepage.services.notcontracted")
                        }}</span>
                      </span>
                    </template>
                    <template v-else>
                      <span class="font-weight-bold m--font-danger">{{
                        $t("homepage.services.notcontracted")
                      }}</span>
                    </template>
                  </div>
                  <br>
                </div>
              </div>
            </div>
          </div>

          <div class="m-widget5__item pt-1 pb-0">
            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <h4 class="m-widget5__title">
                  <span v-if="properties > 0">{{ properties }}</span>
                  {{ $t("services.PropertyService") }}
                  <span class="small">
                    <span
                      v-if="
                        propertyService.ImportType === 'Manual' &&
                          propertyService.ManualSelection === false
                      "
                    >
                      {{ $t("services.ManualUpload") }}
                    </span>
                    <span
                      v-if="
                        propertyService.ImportType === 'XML' &&
                          propertyService.ManualSelection === true
                      "
                    >
                      {{ $t("services.XMLImportManualSelection") }}
                    </span>
                    <span
                      v-if="
                        propertyService.ImportType === 'XML' &&
                          propertyService.ManualSelection === false
                      "
                    >
                      {{ $t("services.XMLImport") }}
                    </span>
                  </span>
                </h4>
              </div>
            </div>

            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <div class="pt-0 m-widget5__stats1">
                  <div>
                    <span v-if="propertyService.Status === 'ACTIVE_SUSPENDED'">
                      <span class="font-weight-bold m--font-danger">{{
                        $t("homepage.services.onhold")
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status === 'ACTIVE_PENDING'">
                      <span class="font-weight-bold m--font-danger">{{
                        $t("homepage.services.pendingactivation")
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status === 'ACTIVE_EXPIRED'">
                      <span class="font-weight-bold m--font-orange">{{
                        $t("homepage.services.activeexpiredWithDate", { date: endDate })
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status === 'ACTIVE_FUTURE'">
                      <span class="font-weight-bold m--font-orange">{{
                        $t("homepage.services.activeFutureWithDate", { date: startDate })
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status === 'ACTIVE'">
                      <span class="font-weight-bold m--font-success">{{
                        $t("homepage.services.active")
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status === 'NOT_ACTIVE'">
                      <span class="font-weight-bold m--font-danger">{{
                        $t("homepage.services.notactive")
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status === 'NO_RESULTS'">
                      <span class="font-weight-bold m--font-danger">{{
                        $t("homepage.services.notcontracted")
                      }}</span>
                    </span>
                  </div>
                  <br>
                </div>
              </div>
            </div>
          </div>
          <template v-if="directories && directories.length > 0">
            <div
              v-for="directory in directories"
              :key="directory.id"
              class="m-widget5__item pt-1 pb-0"
            >
              <div class="m-widget5__content">
                <div class="m-widget5__section">
                  <h4 class="m-widget5__title">
                    {{ $t("Directory.businessListing") }}
                    <span class="small">
                      <template v-if="directory.adInfo.isFeaturedPremium">
                        ({{ $t("Directory.serviceTypes.pro") }})
                      </template>
                      <template v-else-if="directory.adInfo.isFeatured">
                        ({{ $t("Directory.serviceTypes.basicplus") }})
                      </template>
                      <template v-else>
                        ({{ $t("Directory.serviceTypes.basic") }})

                      </template>
                    </span>
                  </h4>
                  <small>{{ directory.name }}</small>
                </div>
              </div>
              <div class="m-widget5__content">
                <div class="m-widget5__section">
                  <div class="pt-0 m-widget5__stats1">
                    <div>
                      <router-link
                        :to="{ name: 'Directories' }"
                        class="btn btn-sm btn-primary font-weight-bold d-block w-100 mb-2"
                      >
                        {{ $t("common.View") }}
                      </router-link>
                      <template v-if="directory.adInfo.isFeatured && !directory.adInfo.isFeaturedPremium">
                        <router-link
                          :to="{ name: 'AdvertiseDir'}"
                          class="btn btn-success btn-sm font-weight-bold b-block w-100"
                        >
                          {{ $t( 'Directory.table.UpgradeToPro' ) }}
                        </router-link>
                      </template>
                      <template v-else-if="!directory.adInfo.isFeatured && !directory.adInfo.isFeaturedPremium">
                        <router-link
                          :to="{ name: 'AdvertiseDir'}"
                          class="btn btn-success btn-sm font-weight-bold b-block w-100"
                        >
                          {{ $t( 'Directory.table.UpgradeNow' ) }}
                        </router-link>
                      </template>
                    </div>
                    <br>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="m-widget5__item pt-1 pb-0">
              <div class="m-widget5__content">
                <div class="m-widget5__section">
                  <h4 class="m-widget5__title">
                    {{ $t( 'Directory.noneFound' ) }}
                  </h4>
                </div>
              </div>
              <div class="m-widget5__content">
                <div class="m-widget5__section">
                  <div class="pt-0 m-widget5__stats1">
                    <div>
                      <router-link
                        :to="{ name: 'Directories'}"
                        class="btn btn-outline-success btn-sm font-weight-bold b-block w-100"
                      >
                        {{ $t( 'Directory.createBusinessListing' ) }}
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <!--end::m-widget5-->
      </div>

      <!--end::Form-->
    </div>
    <!--end::Portlet-->
  </div>
  <!-- End: Services -->
</template>

<script>
import { getUser, getPropertyService, getFeaturedService } from '../../../functions.ts';
import dayjs from 'dayjs';
import { businesslistingsapi } from '../../../api-clients/business-listings-api.js';

export default {
    name: 'Services',
    data() {
        return {
            user: {},
            propertyService: {},
            featuredService: {},
            directories: [],
        };
    },
    computed: {
        premiumFeaturedProperties() {
            return this.featuredService.MaxFeaturedPremium;
        },
        featuredProperties() {
            return this.featuredService.MaxFeaturedStandard;
        },
        properties() {
            return this.propertyService.PropertyLimit;
        },
        startDate() {
            if ( !this.propertyService.StartDate ) {
                return '';
            }
            return dayjs( this.propertyService.StartDate ).tz().format( 'DD/MM/YYYY' );
        },
        endDate() {
            if ( !this.propertyService.EndDate ) {
                return '';
            }
            return dayjs( this.propertyService.EndDate ).tz().format( 'DD/MM/YYYY' );
        },
    },
    async mounted() {
        mApp.block( '#servicesPortlet', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

        this.user = getUser();

        Promise.all( [
            new Promise( async ( resolve ) => {
                this.propertyService = await getPropertyService();
                resolve();
            } ),
            new Promise( async ( resolve ) => {
                this.featuredService = await getFeaturedService();
                resolve();
            } ),
            new Promise( async ( resolve ) => {
                if ( !this.user || !this.user.Login ) {
                    resolve();
                    return;
                }

                const result = await businesslistingsapi.get( `/listings?logins=${this.user.Login}&take=50` );

                if ( result.status === 200 && result.data && result.data.results ) {
                    this.directories = result.data.results;
                }

                resolve();
            } ),
        ] );

        mApp.unblock( '#servicesPortlet' );
    },
};
</script>
